var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileEditPortfolioItem")) {
var t_7 = t_4.MemberProfileEditPortfolioItem;
} else {
cb(new Error("cannot import 'MemberProfileEditPortfolioItem'")); return;
}
context.setVariable("MemberProfileEditPortfolioItem", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"MemberProfileEditPortfolio\">\n        <div class=\"MemberProfileEditPortfolio-note MemberProfileEditPortfolio-note--desktop\">Make sure you don’t post any images of projects that have not yet been released.</div>\n\n        <div class=\"MemberProfileEditPortfolio-body MemberProfileEdit-scrollbox\">\n            <div class=\"MemberProfileEditPortfolio-body-scrollBlock\">\n                <div class=\"MemberProfileEditPortfolio-body-scrollBlock-inner\">\n                    <form class=\"MemberProfileEditPortfolio-body-form\">\n                        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")),"length"))) {
t_9 += "\n                            ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                                ";
t_9 += runtime.suppressValue((lineno = 14, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPortfolioItem"), "MemberProfileEditPortfolioItem", context, [runtime.makeKeywordArgs({"data": t_13,"ind": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")})])), env.opts.autoescape);
t_9 += "\n                            ";
;
}
}
frame = frame.pop();
t_9 += "\n                        ";
;
}
else {
t_9 += "\n                            ";
t_9 += "\n                            ";
t_9 += runtime.suppressValue((lineno = 18, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPortfolioItem"), "MemberProfileEditPortfolioItem", context, [runtime.makeKeywordArgs({"data": {"component": "image"},"ind": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")})])), env.opts.autoescape);
t_9 += "\n                        ";
;
}
t_9 += "\n                    </form>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditPortfolio-buttons\">\n            <div class=\"MemberProfileEditPortfolio-buttons-addBtns\">\n                <div class=\"MemberProfileEditPortfolio-buttons-image\" data-component=\"image\">\n                    <div class=\"MemberProfileEditPortfolio-buttons-imageIcon\">\n                        ";
t_9 += runtime.suppressValue((lineno = 29, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["icon-photo","0 0 60 44",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_9 += "\n                    </div>\n                    <span>Add Image</span>\n                </div>\n                <div class=\"MemberProfileEditPortfolio-buttons-video\" data-component=\"video\">\n                    <div class=\"MemberProfileEditPortfolio-buttons-videoIcon\">\n                        ";
t_9 += runtime.suppressValue((lineno = 35, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["icon-video","0 0 60 40",runtime.makeKeywordArgs({"caller": (function (){var macro_t_16 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_17 = "";;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
return macro_t_16;})()})])), env.opts.autoescape);
t_9 += "\n                    </div>\n                    <span>Add Video</span>\n                </div>\n\n                <div class=\"MemberProfileEditPortfolio-note MemberProfileEditPortfolio-note--mobile\">Make sure you don’t post any images of projects that have not yet been released.</div>\n            </div>\n            <div class=\"MemberProfileEditPortfolio-buttonsInner\">\n                <div class=\"MemberProfileEditPortfolio-buttons-button MemberProfileEditPortfolio-buttons-button--cancel\">\n                    cancel\n                </div>\n                <div class=\"MemberProfileEditPortfolio-buttons-button MemberProfileEditPortfolio-buttons-button--save\">\n                    save\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("MemberProfileEditPortfolio");
context.setVariable("MemberProfileEditPortfolio", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja
// module id = 120
// module chunks = 0